<div class="center" [class.horizinns-container]="!isDialogMode" [class.login-container]="!isDialogMode">
    <mat-card [class.login-card]="!isDialogMode" [class.even-more-blur]="!isDialogMode" [class.dialog-card]="isDialogMode" >
        <mat-card-header>
            <img src="assets/images/logo_full_900.png" alt="Horizinns logo" />
        </mat-card-header>
        <mat-card-content>
            <div class="login-content">
                @if(!loading) {
                    <form [formGroup]="loginForm" (ngSubmit)="submit()" class="form">
                        @if (isInvalidCredentials) {
                            <mat-error>
                                Sorry, we don't recognize that email or password. Please try again.
                            </mat-error>
                        }

                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email" placeholder="Your Email">
                            <mat-icon matPrefix>person</mat-icon>
                            <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
                                Email is required
                            </mat-error>
                        </mat-form-field>
                        
                        <mat-form-field appearance="outline" class="full-width hint__no-padding">
                            <mat-label>Password</mat-label>
                            <mat-icon matPrefix>key</mat-icon>
                            <input matInput formControlName="password" placeholder="Your Password" [type]="hide ? 'password' : 'text'"> 
                            <button mat-icon-button matSuffix type="button" (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="!hide">
                                <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>

                            <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
                                Password is required
                            </mat-error>
                            <mat-hint align="end">
                                <button matButton type="button" routerLink="/forgot-password">Forgot Password</button>
                            </mat-hint>
                        </mat-form-field>

                        <div class="center sign-in-button-container">
                            <!-- <button mat-raised-button color="primary" type="submit">
                                <mat-icon>login</mat-icon> Sign In
                            </button> -->
                            <button mat-flat-button class="metallic-text-btn-blue" type="submit">
                                <i class="fa-solid fa-right-to-bracket"></i>
                                Sign In
                            </button>
                        </div>

                    </form>
                }
                @if (loading) {
                    <div class="loading-container">
                        <app-loader></app-loader>
                        <div class="sign-in-message">Signing In...</div>
                    </div>
                }
            </div>
        </mat-card-content>
        @if(!isDialogMode) {
            <mat-card-footer class="center">
                <div>Don't already have an account with us?</div>
                <button matButton type="button" (click)="handleSignupRedirect()">
                    <mat-icon>person_add</mat-icon>
                    Create An Account
                </button>
            </mat-card-footer>
        }
    </mat-card>
</div>

